window.BoletoEstornoPage={
    watch: {
        required($refField){
            let $refSpan=BoletoEstornoPage.getFieldSpan($refField);
            if (!FormGenericValidator.required($refField.val())) {
                BSForm.error($refField, $refSpan, "Este campo deve ser preenchido");
                return false;
            }
            else{
                BSForm.success($refField,$refSpan);
                return true;
            }
        },
        document_number($refField){
            if(!BoletoEstornoPage.watch.required($refField)) return false;
            let $refSpan=BoletoEstornoPage.getFieldSpan($refField),
                type=$refField.data('type')=="cpf"?"cpf":"cnpj";
            if (!FormGenericValidator[type]($refField.val())) {
                BSForm.error($refField, $refSpan, type.toUpperCase()+" inválido");
                return false;
            }
            else{
                BSForm.success($refField,$refSpan);
                return true;
            }
        },
        form_send: (fields) => {
            let self=BoletoEstornoPage,
                button=$('#btnEnviar,#btnEnviarMobile');

            BSButton.loading(button);

            if(
                self.watch.required(fields.bank_code),
                self.watch.required(fields.office_number),
                self.watch.required(fields.account_number),
                self.watch.required(fields.account_digit),
                self.watch.required(fields.legal_name),
                self.watch.document_number(fields.document_number)
            ){
                $("#formEstornarBoleto").unbind("submit",self.formHandler);
                $('#formEstornarBoleto').submit();
            }
            else{
                BSButton.dismiss(button);
            }
        }
    },
    formHandler: null,
    getFieldSpan($field){
        return $field.parents(".form-group").first().find("span.help-block")
    },
    events(fields){
        this.watch.required(fields.bank_code);

        $.each(fields,(field_name,field) => {
            if((["office_digit","document_number"]).indexOf(field_name) == -1)
              field.change(() => {
                  this.watch.required(field);
              });
          });

        fields.document_number.change(() => {
            this.watch.document_number(fields.document_number);
        });

        this.formHandler=(e) => {
            e.preventDefault();
            this.watch.form_send(fields);
        };
        $("#formEstornarBoleto").submit(this.formHandler);
    },
    masks(fields){
        fields.document_number.mask("000.000.000-00", {
            onKeyPress: function (cpfcnpj, e, field, options) {
                let masks = ['000.000.000-000', '00.000.000/0000-00'],
                    mask = (cpfcnpj.length > 14) ? masks[1] : masks[0],
                    type = (cpfcnpj.length > 14) ? "cnpj" : "cpf";
                fields.document_number.data('type', type).mask(mask, options);
            }
        });

        /**
         * BANK FIELDS MASKS
         */
        fields.office_number.mask('00000'); // Cinco numeros
        fields.office_digit.mask('0'); // Um número
        fields.account_number.mask('0000000000000'); // até 13 numeros
        fields.account_digit.mask('AA'); // Duas letras ou numeros
    },
    load(){
        let $form=document.querySelector('#formEstornarBoleto');
        if($form) {
            let fields = {
                bank_code: $('[name=bank_code]', $form),
                office_number: $('[name=office_number]', $form),
                office_digit: $('[name=office_digit]', $form),
                account_number: $('[name=account_number]', $form),
                account_digit: $('[name=account_digit]', $form),
                legal_name: $('[name=legal_name]', $form),
                document_number: $('[name=document_number]', $form),
            };

            BSForm.success(fields.office_digit, this.getFieldSpan(fields.office_digit));

            BoletoEstornoPage.masks(fields);
            BoletoEstornoPage.events(fields);

        }
    }
};
BoletoEstornoPage.load();